import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Badge, Col, Row } from 'reactstrap';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';
import BlogStyles from './Blog.module.scss';

/**
 * A number, or a string containing a number.
 * @typedef {import('@tryghost/content-api').PostOrPage} Post
 */

/**
 * @typedef {object} BlogPostProps
 * @property {Post} record
 * @property {boolean} [inList]
 */

/**
 *
 * @param {BlogPostProps} props
 * @returns {React.ReactElement}
 */
export function BlogPost(props) {
  const { record, inList } = props;

  if (inList) {
    return (
      <div className={BlogStyles.BlogItem}>
        <Row>
          <Col xs="auto">
            <figure className={BlogStyles.ListImage}>
              <img
                width="200"
                src={record.feature_image}
                alt={record.feature_image_alt}
              />
            </figure>
          </Col>
          <Col className={BlogStyles.BlogItemSummary}>
            <h3 className={cx(BlogStyles.BlogItemTitle, BS.mb3)}>
              <Link to={`/blog/${record.slug}`}>{record.title}</Link>
              <small>
                {moment(record.published_at).format('llll')} —{' '}
                {record.primary_author.name}
              </small>
            </h3>
            <p className={BlogStyles.content}>{record.excerpt}</p>
            <div className={BlogStyles.tags}>
              {record.tags.map(tag => {
                return (
                  <Badge
                    className={BlogStyles.tag}
                    href={`/blog?tags=${encodeURIComponent(tag.slug)}`}
                  >
                    {tag.name}
                  </Badge>
                );
              })}
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className={BlogStyles.BlogItem}>
      <h1 className={cx(BlogStyles.BlogItemTitle, record.tags.length ? BS.mb0 : BS.mb3)}>
        <Link to={`/blog/${record.slug}`}>{record.title}</Link>
        <small>
          {moment(record.published_at).format('llll')} — {record.primary_author.name}
        </small>
      </h1>
      <div className={cx(BlogStyles.tags, BS.mb3)}>
        {record.tags.map(tag => {
          return (
            <Badge
              className={BlogStyles.tag}
              href={`/blog?tags=${encodeURIComponent(tag.slug)}`}
            >
              {tag.name}
            </Badge>
          );
        })}
      </div>
      {record.excerpt && <p className={BlogStyles.BlogItemExcerpt}>{record.excerpt}</p>}
      {record.feature_image && (
        <figure class="gh-article-image">
          <img src={record.feature_image} alt={record.feature_image_alt} />
          {record.feature_image_caption && (
            <figcaption
              dangerouslySetInnerHTML={{ __html: record.feature_image_caption }}
            />
          )}
        </figure>
      )}
      <div
        className={BlogStyles.content}
        dangerouslySetInnerHTML={{ __html: record.html }}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/blog/post.js